import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, paginate } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

export type TrainingItemCategory = {
  _id: string
  display: string
  isMultiple: boolean
  isMandatory: boolean
}

const resource = 'trainingItemCategorys'

const filter = (axios: IFactoryFunctionRequest<paginate<TrainingItemCategory>, undefined>) => (options = {}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query: options,
  })
}

const getAll = (axios: IFactoryFunctionRequest<TrainingItemCategory[], undefined>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/all`,
  })
}

const create = (axios: IFactoryFunctionRequest<TrainingItemCategory, any>) => (data: {
  display: string
  isMultiple?: boolean
  isMandatory?: boolean
}) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/create`,
    data,
  })
}

const update = (axios: IFactoryFunctionRequest<TrainingItemCategory, any>) => (id: string, data: {
  display?: string
  isMultiple?: boolean
  isMandatory?: boolean
}) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/update/${id}`,
    data,
  })
}

const deleteOne = (axios: IFactoryFunctionRequest<unknown, undefined>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/delete/${id}`,
  })
}

export default (axios: AxiosInstance) => ({
  filter: filter(useAxios(axios)),
  getAll: getAll(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
  deleteOne: deleteOne(useAxios(axios)),
})
